import { Button } from '@flowus/common/components';
import { useOpenModal } from '@flowus/common/next-modal';
import type { PermissionDTO } from '@next-space/fe-api-idl';
import { useEffect, useMemo, useState, type FC } from 'react';
import { request } from 'src/common/request';
import { useBlock } from 'src/hooks/block/use-block';
import { CopyToSpace } from 'src/hooks/share/use-copy-to-space';
import { useGetPageId } from 'src/utils/getPageId';

export const UseTemplateButton: FC = () => {
  const pageId = useGetPageId();
  const block = useBlock(pageId);
  const [showBtn, setShowBtn] = useState(false);
  const openModal = useOpenModal();
  const hasAccessFee = useMemo(() => {
    return hasAccessFeeAndCanDuplicate(block?.permissions ?? []);
  }, [block?.permissions]);

  useEffect(() => {
    if (!hasAccessFee) return;
    void request.infra
      .checkTemplatePage({
        docIds: [pageId],
      })
      .then((res) => {
        if (res.length) {
          setShowBtn(res[0]?.isTemplate ?? false);
        }
      });
  }, [hasAccessFee, pageId]);

  if (!showBtn) {
    return null;
  }

  return (
    <div className="w-full fixed bottom-10 z-[999]">
      <div className="w-full flex justify-center items-center">
        <Button
          colorType="active"
          className="w-80 h-9"
          onClick={(e) => {
            openModal.dropdown({
              popcorn: e.currentTarget,
              placement: 'bottom-end',
              offset: [0, 16],
              content: ({ onCloseModal }) => (
                <CopyToSpace
                  addCopyLimit={false}
                  uuid={pageId}
                  onSelectSpace={() => {
                    onCloseModal();
                  }}
                />
              ),
            });
          }}
        >
          使用模板
        </Button>
      </div>
    </div>
  );
};
const hasAccessFeeAndCanDuplicate = (permissions: PermissionDTO[]) => {
  let hasAccessFee = false;
  let allowDuplicate = false;

  for (const p of permissions) {
    if (p.accessFee) {
      hasAccessFee = true;
    }
    if (p.allowDuplicate) {
      allowDuplicate = true;
    }
  }
  return hasAccessFee && allowDuplicate;
};
